// services/EnrollmentService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getEnrollments(params = {}) {
    return api.get(ENDPOINTS.ENROLLMENTS.BASE, { params });
}
export function getEnrollmentById(id) {
    return api.get(ENDPOINTS.ENROLLMENTS.BY_ID(id));
}
export function createEnrollment(payload) {
    return api.post(ENDPOINTS.ENROLLMENTS.BASE, payload);
}
export function updateEnrollment(id, payload) {
    return api.patch(ENDPOINTS.ENROLLMENTS.BY_ID(id), payload);
}
export function deleteEnrollment(id) {
    return api.delete(ENDPOINTS.ENROLLMENTS.BY_ID(id));
}
export function restoreEnrollment(id) {
    return api.post(`${ENDPOINTS.ENROLLMENTS.BY_ID(id)}/restore`);
}
